import { Icon } from './_Icon';
export const MenuIcon = (props) => <Icon {...props} d="M3 6h18 M3 12h18 M3 18h18" />;
